import React, { useEffect, useState } from 'react'
import { EventEmitter } from '../../utils/EventEmitter';

type Props = {
  size?: number;
}

export default function AlidaLoader({ size = 100 }: Props) {
  const [timestamp, setTimestamp] = useState(new Date().getTime());

  useEffect(() => {
    EventEmitter.subscribe('update-timestamp', (ts: number) => setTimestamp(ts));
  }, []);

  return (
    <img
      className="alida-loader"
      alt="Alida Logo"
      src={`${window.__env.GREY_LOGO_URL}?t=${timestamp}`}
      width={size}
    />
  );
}
